module.exports = "/_next/static/images/OgImage-821b7f6403ebd2cbccf5382a86f7f4f0.jpg";